/*
 * SKZLiveEvent.js
 * SkillzSDK-iOS
 *
 * Created by Skillz on 2/23/16.
 * Copyright © 2016 Skillz. All rights reserved.
 *
 * @providesModule SKZLiveEvent
 * 
 */

import _ from 'lodash';

export class BannerMedia {
  path: string;
}

export class LiveEventRecord {
  id: string;
  name: string;
  description: string;
  entries: number;
  logo: string;
  start: string;
  end: string;
  event_url: string;
  stream_url: string;
  signup_url: string;
  minimum_age: number;
  subscribed: boolean;
  user_registered: boolean;
  share_message: string;
  match_code_required: string;
  banner_media: Array<BannerMedia>;
  current_user_total_cash_entries: number;
  current_user_total_free_roll_entries: number;
  rules_description_markdown: string;
}

export default class LiveEvent extends LiveEventRecord {

  constructor(keyValueSource: Object) {
    super();
    return _.create(LiveEvent.prototype, keyValueSource);
  }

  getTotalEntriesForCurrentUser(): number {
    return this.current_user_total_cash_entries + this.current_user_total_free_roll_entries;
  }

  hasBannerMedia(): boolean {
    return this.banner_media?.length > 0;
  }

  getHostedEventShareImage(): string | null {
    if (this.hasBannerMedia()) {
      let imageURL: string | null = null;

      _.forEach(this.banner_media, (media: BannerMedia) => {
        const url = media.path;
        if (url.match(/\.(jpeg|jpg|png)$/i) != null && imageURL == null) {
          imageURL = url;
        }
      });

      return imageURL;
    }

    return null;
  }
}
